import * as React from 'react';
import { Paper } from '@mui/material';
import PropTypes from 'prop-types';

function WithFixed({
  children,
  bottom = 0,
  top = 'initial',
  left = 0,
  right = 0,
}) {
  return (
    <>
      {/* toolbar height */}
      {/* <Box sx={{ height, flex: 1 }} /> */}
      <Paper sx={{ bottom, left, right, top, zIndex: 2 }} elevation={3}>
        {children}
      </Paper>
    </>
  );
}

WithFixed.propTypes = {
  height: PropTypes.number,
  bottom: PropTypes.number,
  top: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
};
export default WithFixed;
